import React from 'react'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { Box, Chip, Stack, Typography } from '@mui/material'

import Tooltip from './Tooltip'

const classes = {
  chip: 'chip',
}
const Root = styled('section')(({ theme }) => ({
  [`& .${classes.chip}`]: {
    height: 'auto',
    lineHeight: '1.5',
    marginLeft: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
  },
  // [`& .${classes.chip} .MuiChip-label`]: {
  // paddingLeft: theme.spacing(0.75),
  // paddingRight: theme.spacing(0.75),
  // },
}))

export default function TableHeaderCell({
  label,
  errorsNumber,
  errorColor,
  filter,
  hasTooltip,
  tooltipLabel,
  tooltipProps,
  labelProps,
}) {
  const TooltipContainer = hasTooltip ? Tooltip : React.Fragment

  return (
    <Root>
      <TooltipContainer
        {...(hasTooltip
          ? {
              title: tooltipLabel ? (
                <Typography variant="body2">{tooltipLabel}</Typography>
              ) : undefined,
              followCursor: true,
              placement: 'top-start',
              ...tooltipProps,
            }
          : {})}
      >
        <Stack direction="row" alignItems="center">
          <Box component="span" {...labelProps}>
            {label}
          </Box>
          {!!errorsNumber && (
            <Chip
              className={classes.chip}
              size="small"
              label={errorsNumber}
              color={errorColor || 'error'}
            />
          )}
        </Stack>
      </TooltipContainer>
      {filter && (
        <>
          <Box pb={0.5} />
          <div onClick={(e) => e.stopPropagation()}>{filter}</div>
        </>
      )}
    </Root>
  )
}

TableHeaderCell.propTypes = {
  label: T.string,
  errorsNumber: T.number,
  errorColor: T.string,
  filter: T.node,
  hasTooltip: T.bool,
  tooltipLabel: T.string,
  tooltipProps: T.object,
  labelProps: T.object,
}
